import Vue from "vue";
import { alertError } from "@/utils/alert";
import { isNumberLike } from "@/utils/common";

// 半角符号(英文+英文符号)
Vue.prototype.$halfWidthRegex = /[^\x00-\xff]/g;
// 数字
Vue.prototype.$numRegex = /[^\d]/g;
// 判断是否是字符串数字或数字
Vue.prototype.$isNumberLike = isNumberLike;
// 弹窗
Vue.prototype.$alertError = alertError;
